const vuetifyTheme = {
  primary: "#0092b2",
  secondary: "#ffdc5f",
  accent: "#0092b2"
};

const menu = [
  {
    path: "/",
    name: "Início"
  },
  {
    name: "Institucional",
    dropdown: [
      { path: "/institucional/o-colegio", name: "O Colégio" },
      { path: "/institucional/equipe", name: "Equipe" },
      {
        path: "/institucional/quem-foi-jean-piaget",
        name: "Quem foi Jean Piaget?"
      },
      {
        path: "/institucional/proposta-pedagogica",
        name: "Proposta Pedagógica"
      }
    ]
  },
  {
    path: "/ensino",
    name: "Ensino"
  },
  {
    path: "/biblioteca",
    name: "Biblioteca"
  },
  {
    name: "Espaço do Aluno",
    dropdown: [
      // {
      //   path: "/aluno/atividades-e-compromissos",
      //   name: "Atividades e Compromissos"
      // },
      { path: "/aluno/links-uteis", name: "Links Úteis" },
      { path: "/aluno/dicas-interessantes", name: "Dicas Interessantes" },
      { path: "/aluno/licao-de-casa", name: "Lição de Casa" }
    ]
  },
  {
    name: "Novidades",
    dropdown: [
      { path: "/novidades/noticias", name: "Notícias" },
      { path: "/novidades/galerias", name: "Galerias" },
      { path: "/novidades/videos", name: "Vídeos" },
      { path: "/novidades/projetos", name: "Projetos" },
      { path: "/novidades/comunicados", name: "Comunicados da Escola" }
    ]
  },
  {
    name: "Contato",
    path: "/contato"
  }
];

export { vuetifyTheme, menu };
